module.exports = __webpack_public_path__ + "static/media/Mask Group-2.4c022172.png";